import { ACoreXUIModule } from '@acorex/ui';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AXFEditorService } from '../../../services/editor.service';
import { AXFColorEditorComponent } from './color.editor';

@NgModule({
  declarations: [AXFColorEditorComponent],
  imports: [CommonModule, ACoreXUIModule],
  exports: [AXFColorEditorComponent],
  entryComponents: [AXFColorEditorComponent],
  providers: [],
})
export class AXFColorEditorModule {
  constructor(service: AXFEditorService) {
    service.register('ColorEditor', AXFColorEditorComponent);
  }
}
